import EmbeddedLayout from '../../layouts/EmbeddedLayout';
import AppPairingContent from '../shared/AppPairingContent';

type Props = {
  pairingCode: string;
  onCancel: () => void;
  onCompletePairing: () => void;
  onBack?: () => void;
};

export default function EmbeddedAppPairingPage(props: Props) {
  return (
    <EmbeddedLayout>
      <AppPairingContent {...props} />
    </EmbeddedLayout>
  );
}
